import { render, staticRenderFns } from "./SwitchSelector.vue?vue&type=template&id=1b48ee98&scoped=true&"
import script from "./SwitchSelector.vue?vue&type=script&lang=js&"
export * from "./SwitchSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b48ee98",
  null
  
)

export default component.exports